import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import ImportedShapefileProperties from './ImportedShapefileProperties';
import { toDateString } from '../../../utils/date';
import Card from '../cardAndPreview/Card';
import styles from '../cardAndPreview/cardAndPreview.css';

export function ImportedShapefileCard(props) {
  const { activeShapefile, locale, properties = [] } = props;
  const datetime = toDateString(activeShapefile.eventDate, locale);
  const numberOfFiles = properties.length || 0;
  let err =
    !properties.length &&
    activeShapefile &&
    getMessage('card.importedShapefile.noData');
  err = err || undefined;

  return (
    <Card
      errorMessage={err}
      id={activeShapefile.id}
      isLoading={!properties.length && !err}
      testId="dmb-imported-shapefile-card"
      title={activeShapefile.filename}
    >
      <p className={styles.subtitle}>
        {datetime} &bull;{' '}
        {getMessage('card.importedShapefiles.files', { numberOfFiles })}
      </p>
      <ImportedShapefileProperties {...props} />
    </Card>
  );
}

ImportedShapefileCard.propTypes = {
  activePropertyIndex: PropTypes.number.isRequired,
  activeShapefile: PropTypes.object.isRequired,
  locale: PropTypes.string,
  onClick: PropTypes.func,
  properties: PropTypes.array,
};

export default ImportedShapefileCard;
